(function ($) {
    'use strict';

    function getState($section) {
        var sectionId = $section.data('section-id');
        if (!window.PCCompare || !window.PCCompare[sectionId]) {
            return null;
        }
        return window.PCCompare[sectionId];
    }

    function applyPresets(state) {
        if (!state || state._presetsApplied) {
            return;
        }
        state._presetsApplied = true;
        state.compare = [];

        var presetIds = (state.presetIds || []).slice(0, state.columnCount || 3);
        presetIds.forEach(function (id) {
            if (!id) {
                return;
            }
            var matchingProduct = state.products.find(function (product) {
                return String(product.id) === String(id);
            });
            if (matchingProduct) {
                state.compare.push(matchingProduct);
            }
        });
    }

    function getCompare($section) {
        var state = getState($section);
        if (!state) {
            return;
        }

        applyPresets(state);

        var $dataProducts = $section.find('.compare .data--product');
        var $placeholders = $section.find('.compare .data--placeholder');
        var $btnSelects = $section.find('.selection .btn-select');

        $section.find('.compare .data').html('');
        $dataProducts.find('img').attr('src', '');
        $dataProducts.find('a').attr('href', '');
        $dataProducts.find('.product-title').html('');
        $dataProducts.find('.product-price').html('');
        $dataProducts.find('.color-swatch').html('');
        $dataProducts.css('display', 'none');
        $placeholders.css('display', 'flex');
        $btnSelects.attr('data-selected', '').find('div').html('Select');
        $section.find('.model').removeClass('active');

        var idx = 0;
        state.compare.forEach(function (product) {
            var colorHTML = '';
            (product.color_hex || []).forEach(function (color) {
                if (color && typeof color === 'object') {
                    if (color.type === 'image') {
                        colorHTML += '<span class="swatch" style="background-image: url(\'' + color.value + '\');"></span>';
                    } else {
                        colorHTML += '<span class="swatch" style="background-color: ' + color.value + ';"></span>';
                    }
                } else if (color) {
                    colorHTML += '<span class="swatch" style="background-color: ' + color + ';"></span>';
                }
            });

            $dataProducts.eq(idx).find('.color-swatch').html(colorHTML);

            $btnSelects.eq(idx).attr('data-selected', product.id);
            $btnSelects.eq(idx).find('div').html(product.title);

            $dataProducts.eq(idx).css('display', 'flex');
            $placeholders.eq(idx).css('display', 'none');

            $dataProducts.eq(idx).find('img').attr('src', product.featured_image);
            $dataProducts.eq(idx).find('.product-title').html(product.title);

            var $price = $dataProducts.eq(idx).find('.product-price');
            if (product.hidden_price) {
                $price.html('&nbsp;');
            } else {
                $price.html(product.price);
            }

            $dataProducts.eq(idx).find('a').attr('href', product.url);

            $section.find('.compare .data--color').eq(idx).html(product.color);
            $section.find('.compare .data--frame_style').eq(idx).html(product.frame_style);
            $section.find('.compare .data--mode').eq(idx).html(product.mode);
            $section.find('.compare .data--power').eq(idx).html(product.power);
            $section.find('.compare .data--battery_capacity').eq(idx).html(product.battery_capacity);
            $section.find('.compare .data--charging_time').eq(idx).html(product.charging_time);
            $section.find('.compare .data--assist_speed').eq(idx).html(product.assist_speed);
            $section.find('.compare .data--range').eq(idx).html(product.range);
            $section.find('.compare .data--rider_height').eq(idx).html(product.rider_height);
            $section.find('.compare .data--rear_derailleur').eq(idx).html(product.rear_derailleur);
            $section.find('.compare .data--front_fork').eq(idx).html(product.front_fork);
            $section.find('.compare .data--motor').eq(idx).html(product.motor);
            $section.find('.compare .data--sensor').eq(idx).html(product.sensor);
            $section.find('.compare .data--charger').eq(idx).html(product.charger);
            $section.find('.compare .data--controller').eq(idx).html(product.controller);
            $section.find('.compare .data--torque').eq(idx).html(product.torque);
            $section.find('.compare .data--suspension').eq(idx).html(product.suspension);
            $section.find('.compare .data--display').eq(idx).html(product.display);
            $section.find('.compare .data--brakes').eq(idx).html(product.brakes);
            $section.find('.compare .data--tires').eq(idx).html(product.tires);
            $section.find('.compare .data--seat_post').eq(idx).html(product.seat_post);
            $section.find('.compare .data--bike_weight').eq(idx).html(product.bike_weight);

            $section.find('.model[data-model="' + product.id + '"]').addClass('active');

            idx++;
        });

        // Keep legacy globals in sync with the active section
        if (typeof window.compare !== 'undefined') {
            window.compare = state.compare;
        }
        if (typeof window.compare_products !== 'undefined') {
            window.compare_products = state.products;
        }
    }

    function initSection($section) {
        if (!$section.length || $section.data('pc-initialized')) {
            return;
        }
        $section.data('pc-initialized', true);

        var state = getState($section);
        if (!state) {
            return;
        }

        applyPresets(state);
        getCompare($section);

        $section.find('.btn-select').hover(function () {
            var $models = $section.find('.models');
            if ($(window).outerWidth() >= 1280) {
                var btnRight = $(this).position().left + $(this).outerWidth();
                var modelsWidth = $models.outerWidth();
                var modelsLeft = btnRight - modelsWidth;
                $models.css('left', modelsLeft);
                $models.show();
            } else if ($(window).outerWidth() >= 768) {
                $models.css('left', '30px');
                $models.show();
            } else {
                $models.css('left', '20px');
                $models.show();
            }
        });

        $section.find('.selection, .models').mouseenter(function () {
            var $models = $section.find('.models');
            if ($models.is(':visible')) {
                $models.show();
            }
        }).mouseleave(function () {
            var $models = $section.find('.models');
            if (!$models.is(':hover')) {
                $models.hide();
            }
        });

        $section.find('.model').on('click', function () {
            var maxColumns = state.columnCount || 3;
            var $model = $(this);
            var modelId = $model.data('model');

            if (!$model.hasClass('active')) {
                if (state.compare.length < maxColumns) {
                    $model.addClass('active');

                    var matchingProduct = state.products.find(function (product) {
                        return String(product.id) === String(modelId);
                    });

                    if (matchingProduct) {
                        state.compare.push(matchingProduct);
                    }

                    getCompare($section);
                }
            } else {
                $model.removeClass('active');

                var index = state.compare.findIndex(function (product) {
                    return String(product.id) === String(modelId);
                });

                if (index !== -1) {
                    state.compare.splice(index, 1);
                }

                getCompare($section);
            }
        });
    }

    function initAll() {
        $('.product-comparison[data-section-id]').each(function () {
            initSection($(this));
        });
    }

    // Expose for theme editor / legacy callers
    window.getCompare = function ($section) {
        if ($section && $section.length) {
            getCompare($section);
            return;
        }
        $('.product-comparison[data-section-id]').each(function () {
            getCompare($(this));
        });
    };

    $(document).on('shopify:section:load', function (event) {
        var $section = $(event.target).find('.product-comparison[data-section-id]');
        if (!$section.length && $(event.target).hasClass('product-comparison')) {
            $section = $(event.target);
        }
        if ($section.length) {
            $section.removeData('pc-initialized');
            var state = getState($section);
            if (state) {
                state._presetsApplied = false;
            }
            initSection($section);
        }
    });

    $(document).ready(function () {
        initAll();
    });
})(jQuery);
